module.exports = __webpack_public_path__ + "static/media/54524417_587104311776189_2637942091132436480_o.cca8a146.jpg";